// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3GaoP55EqKA862Gak5WDCr"};